export const zhHK = {
  importantNotes: '重要聲明:',
  }
